import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

export default function MocklHeader() {
  const location = useLocation();
  const pathname = location.pathname;

  const initialMenu =
    localStorage.getItem("myMenu") ||
    "light-style layout-navbar-fixed layout-compact layout-menu-fixed";
  const initialToggle = localStorage.getItem("myToggle") === "true";

  const [menu, setMenu] = useState(initialMenu);
  const [toggle, setToggle] = useState(initialToggle);
  const [activeDropdown, setActiveDropdown] = useState("");

  useEffect(() => {
    localStorage.setItem("myMenu", menu);
    localStorage.setItem("myToggle", toggle);
    document.documentElement.className = menu;
  }, [menu, toggle]);

  const changeMenuOnHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed layout-menu-hover"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOffHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOnClick = () => {
    setMenu(
      "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
    );
    setToggle(!toggle);
  };
return (
    <>
      <style>{`
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme hide-scrollbar"
        onMouseOver={changeMenuOnHover}
        onMouseOut={changeMenuOffHover}
        style={{
          maxHeight: "150vh",
          overflowY: "auto",
          borderRight: "1px solid #696cff",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        <div className="app-brand demo">
          <Link to={"/"} className="app-brand-link">
            <span className="app-brand-text demo menu-text fw-semibold ms-2">
              <img
                src={"https://test.scaiarj.com/logo/mainLogo.png"}
                alt=""
                style={{ resize: "contain", width: "150px", height: "50px" }}
              />
            </span>
          </Link>

          <a
            href="#"
            className="layout-menu-toggle menu-link text-large ms-auto"
          >
            <i
              className="menu-toggle-icon d-xl-block align-middle"
              onClick={changeMenuOnClick}
            />
          </a>
        </div>
        <div className="menu-inner-shadow" />

        <ul className="menu-inner py-1">
          <li
            className={`menu-item ${
              pathname === "/mock/series" ? "active" : ""
            }`}
          >
            <Link to="/mock/series" className="menu-link">
              <i className="bi bi-hourglass-split me-2"></i>
              <div>Test Series List</div>
            </Link>
          </li>
          <li
            className={`menu-item ${
              pathname === "/mock/create/test" ? "active" : ""
            }`}
          >
            <Link to="/mock/create/test" className="menu-link">
              <i className="bi bi-hourglass-split me-2"></i>
              <div>Create Test</div>
            </Link>
          </li>


          <li
            className={`menu-item ${
              pathname === "/mock/test/list" ? "active" : ""
            }`}
          >
            <Link to="/mock/test/list" className="menu-link">
              <i className="bi bi-hourglass-split me-2"></i>
              <div>Test List</div>
            </Link>
          </li>


          <li
            className={`menu-item ${
              pathname === "/mock/test/panel" ? "active" : ""
            }`}
          >
            <Link to="/mock/test/panel" className="menu-link">
              <i className="bi bi-hourglass-split me-2"></i>
              <div>Test Panel</div>
            </Link>
          </li>

          <li className={`menu-item ${pathname === "/logout" ? "active" : ""}`}>
            <Link to="/logout" className="menu-link">
              <i className="ri-logout-circle-r-line menu-icon tf-icons me-2 text-danger"></i>
              {/* <i className="bi bi-headset menu-icon tf-icons me-2"></i> */}
              <div>Log Out</div>
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
}
